module.exports = __webpack_public_path__ + "img/image_20.45503030.png";